import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { PageHero } from "../components/Shared";
import { QuoteFormSection } from "../components/QuoteForm";
import {
  PHONE, PHONE_LINK, EMAIL, FACEBOOK_URL, INSTAGRAM_URL,
  FONT_HEAD, FONT_BODY, NAVY, GOLD,
} from "../lib/constants";

const CONTACT_CARDS = [
  { Icon: Phone, title: "Call or Text", value: PHONE, href: PHONE_LINK, testid: "contact-card-phone" },
  { Icon: Mail, title: "Email Us", value: EMAIL, href: `mailto:${EMAIL}`, testid: "contact-card-email" },
  { Icon: MapPin, title: "Service Area", value: "Naples, FL — Collier County", testid: "contact-card-area" },
  { Icon: Clock, title: "Response Time", value: "Quotes within 24 hours", testid: "contact-card-hours" },
];

const CARD_CLASS =
  "bg-white p-6 text-center shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 block";
const CARD_STYLE = { border: "1px solid rgba(27,58,107,0.08)" };

const ContactCard = ({ Icon, title, value, href, testid }) => {
  const Tag = href ? "a" : "div";
  return (
    <Tag href={href} data-testid={testid} className={CARD_CLASS} style={CARD_STYLE}>
      <div className="w-12 h-12 flex items-center justify-center mb-4 mx-auto" style={{ background: "rgba(212,168,67,0.15)", borderRadius: "2px" }}>
        <Icon size={22} style={{ color: GOLD }} />
      </div>
      <h3 className="text-sm font-bold mb-1" style={{ fontFamily: FONT_HEAD, color: NAVY }}>
        {title}
      </h3>
      <p className="text-sm" style={{ color: "#6B7280", fontFamily: FONT_BODY }}>
        {value}
      </p>
    </Tag>
  );
};

const SocialButtons = () => (
  <div className="flex justify-center gap-4 mt-10">
    <a
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contact-social-facebook"
      className="flex items-center gap-2 px-5 py-2.5 text-sm font-bold transition-all duration-300 hover:opacity-90"
      style={{ background: NAVY, color: "#FFFFFF", fontFamily: FONT_BODY }}
    >
      <Facebook size={15} />
      Facebook
    </a>
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="contact-social-instagram"
      className="flex items-center gap-2 px-5 py-2.5 text-sm font-bold border-2 transition-all duration-300 hover:bg-[#1B3A6B] hover:text-white"
      style={{ borderColor: NAVY, color: NAVY, fontFamily: FONT_BODY }}
    >
      <Instagram size={15} />
      Instagram
    </a>
  </div>
);

const ContactInfo = () => (
  <section data-testid="contact-info-section" className="py-14" style={{ background: "#F9FAFB" }}>
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {CONTACT_CARDS.map((card) => (
          <ContactCard key={card.testid} {...card} />
        ))}
      </div>
      <SocialButtons />
    </div>
  </section>
);

export default function ContactPage() {
  return (
    <>
      <PageHero
        testid="contact-page-hero"
        badge="Contact Us"
        title={<>Let's Get Your Space <span style={{ color: GOLD }}>Spotless</span></>}
        subtitle="Request a free quote below, or call us directly — we respond to every request within 24 hours."
      />
      <ContactInfo />
      <QuoteFormSection />
    </>
  );
}
